module.exports = __webpack_public_path__ + "img/auth-page-icon.05e064c2.svg";